import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { createAppRoutes } from "@/app/createAppRoutes";
import { reloadIfUpdatePending } from "@/infrastructure/versionSkew";

const router = createBrowserRouter(createAppRoutes());

// Apply a pending deploy only when navigation would already remount the page.
let lastPathname = window.location.pathname;
router.subscribe((state) => {
  if (state.location.pathname === lastPathname) return;
  lastPathname = state.location.pathname;
  reloadIfUpdatePending();
});

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
